import { createContext, useContext } from "react";
import { OrganizationIntegrationAccountItem } from "@common/schemas/organization-connection-groups.schema";

export interface OrgReconnectContextValue {
    reconnect: (item: OrganizationIntegrationAccountItem) => void;
    /**
     * Connections currently mid-reconnect, so their rows can show progress.
     * A set, not one id: reconnects on different providers post back through
     * different channels and can legitimately overlap.
     */
    reconnectingConnectionIds: ReadonlySet<string>;
}

export const OrgReconnectContext =
    createContext<OrgReconnectContextValue | null>(null);

export function useOrgReconnect() {
    const context = useContext(OrgReconnectContext);
    if (!context) {
        throw new Error(
            "useOrgReconnect must be used within an OrgIntegrationReconnectProvider",
        );
    }
    return context;
}
